import React from 'react';
import Meta from '../components/Meta';
import { useLocation } from 'react-router-dom';

function UnauthorizedPage(props) {
  const location = useLocation();

  return (
    <>
      <Meta title="403" />
      <div className="min-h-screen w-full bg-slate-100 p-12 pt-28 text-center">
        You don't have acces to the page <code>{location.pathname}</code>. Please contact
        info@showrunner.co to request an admin account and manage your organiation's shows.
      </div>
    </>
  );
}

export default UnauthorizedPage;
